__turbopack_context__.v({
  "child": "O7DgFW_child",
  "label": "O7DgFW_label",
  "leaves": "O7DgFW_leaves",
  "list": "O7DgFW_list",
  "parent": "O7DgFW_parent",
  "wrap": "O7DgFW_wrap",
});
